import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, Spacing, TextInput } from '../../types'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class ColorContainerHeadlineConverter extends CmsConverterService<ColorContainerHeadlineData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      headline: formData.st_headline ?? defaultTextInput,
      spacing: {
        bottom: formData.st_spacing_bottom?.value?.identifier ?? '',
        top: formData.st_spacing_top?.value?.identifier ?? ''
      },
      textCentered: formData.st_center_headline?.value ?? false,
    }
  }
}

export const COLOR_CONTAINER_HEADLINE_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, ColorContainerHeadlineData>>('ColorContainerHeadlineConverter')

export interface ColorContainerHeadlineData extends ConvertedComponentData {
  headline: TextInput;
  spacing: Spacing;
  textCentered: boolean;
}
